import React from "react";
import { AiOutlineDoubleRight } from "react-icons/ai";

export const ExArticle = ({ data, value }) => {
  const { title, dates, duties, company } = data[value];
  return (
    <article className="exArticle">
      <h2>{title}</h2>
      <h5 className="h5">{company}</h5>
      <h5 className="date">{dates}</h5>
      <div>
        {duties.map((duty, index) => {
          return (
            <div key={index} className="inside-text-flex-ex">
              <AiOutlineDoubleRight className="icon-style" />
              <p className="ex-p">{duty}</p>
            </div>
          );
        })}
      </div>
    </article>
  );
};
